import React from "react";
import BaseComponent from "../BaseComponent";
import Input from "../Input";
import Dropdown from "../Dropdown";
import Button from "../Button";
import { Constant } from '../../const';

export default class ExitSubCon extends BaseComponent {
    /**
     * Submenu view for argument definition lists (inputs)
     * @module ExitSubCon
     * @param {Object} props React props
     */
    constructor(props){
        super(props);
        this.varModel = this.isKnownModel() ? this.props.data.variable : this.initVarModel();
        this.varIdx = (this.props.data && this.props.data.varIdx) ? this.props.data.varIdx : 0;
    }

    /**
     * Initialize dummy data model
     * @returns {Object}
     */
    initVarModel(){
        return {
            argumentName: null,
            id: Utility.uuid4(),
            type: "variable",
            value: null,
            varName: null,
            intent: null,
            sensitiveData: false
        };
    }

    /**
     * Set config proxy; catches own input value updates and update its data model before saving to list
     * @param {string} key
     * @param {string|boolean} value
     */
    setConfig(key, value){
        this.varModel[key] = value;
        if (key === "type"){
            this.forceUpdate();
        }
    }

    getConfig(key){
        return this.varModel[key];
    }

    isValidVar(){
        var isValidVar = false;
        const sv = this.varModel.varName.split(".");
        if (sv[0] === Constant.k.SCOPE_APPLICATION && window.apm.getVariable(sv[1])) {
            var appVariable = window.apm.getVariable(sv[1]);
            //this.varModel.id = appVariable.id;
            this.varModel.sensitiveData = appVariable.props.config.sensitiveData;
            isValidVar = true;
        }
        var localVariable = window.apm.getVariable(sv[1], window.apm.getCurrentDiagramWidget().props.node.id);
        if (sv[0] === Constant.k.SCOPE_MODULE &&localVariable) {
            //this.varModel.id = localVariable.id;
            this.varModel.sensitiveData = localVariable.props.config.sensitiveData;
            isValidVar = true;
        }
        return isValidVar;
    }

    isValidModel(){
        return (this.varModel.value || (this.varModel.varName && this.isValidVar()) || this.varModel.intent);
    }

    isKnownModel(){
        return this.props.data && this.props.data.variable;
    }

    /**
     * React render
     * @returns {XML}
     */
    render() {
        const preSelection = window.apm.knowledgeBase.getIndexFromValue(this.varModel.type, window.apm.knowledgeBase.getNodeExitTypes());
        var preIntSelection = -1;
        if (this.varModel.intent){
            preIntSelection = window.apm.knowledgeBase.getIndexFromValue(this.varModel.intent, window.apm.knowledgeBase.getIntents());
        }

        return (
            <div>
                {<Dropdown wide={true} label={this.getPropLabel("output_value_from")} optionName={this.getPropLabel("type_opt")}
                           options={window.apm.knowledgeBase.getNodeExitTypes()}
                            context={this} valKey={"type"}
                            selection={preSelection} />}
                {this.varModel.type === "VALUE" &&
                    <Input label={this.getPropLabel("output_value")} hint={this.getPropLabel("output_value_hint")}
                           context={this} valKey={"value"} value={this.varModel.value} />}
                {this.varModel.type === "VARIABLE" &&
                    <Input label={this.getPropLabel("scoped_variable_name")} hint={this.getPropLabel("scoped_variable_name_hint")}
                           context={this} valKey={"varName"} value={this.varModel.varName}  valRules={{ "varName":true}}suggestion={"variable"}/>}
                {this.varModel.type === "INTENT" &&
                    <Dropdown wide={true} label={this.getPropLabel("intent")} optionName={this.getPropLabel("select_intent")}
                              options={window.apm.knowledgeBase.getIntents()}
                              context={this} valKey={"intent"}
                              selection={preIntSelection} />}
                {(() => {
                     if(this.props.readOnly){
                        return
                            <label>{this.getPropLabel("read_only")}</label>;
                        
                    }
                    if (this.isValidModel()) {
                        var DelBtn = null;
                        if (!this.props.params || (this.props.params && !this.props.params.updateOnly)){
                            DelBtn = <td style={{paddingRight: "2px"}}>
                                <Button icon={"icon-trash"} tint={"warning"}
                                        callback={() => {
                                            this.props.context.remove(this.varIdx);
                                            this.varModel = this.initVarModel();
                                            this.props.domContext.removeSubmenu();
                                        }}
                                />
                            </td>;
                        }
                        // Display edit and delete for editing
                        return (
                            <table style={{width: "100%"}}><tbody><tr>
                                {DelBtn}
                                <td>
                                    {<Button label={this.getPropLabel("save_output")} wide={true}
                                             callback={() => {
                                                 if (this.isValidModel()){
                                                     this.props.context.update(this.varModel, this.varIdx);
                                                 }
                                                 this.varModel = this.initVarModel();
                                                 this.props.domContext.removeSubmenu();
                                             }}
                                    />}
                                </td>
                            </tr></tbody></table>
                        );
                    }
                    return (
                        <Button label={this.getPropLabel("add_output")} wide={true}
                                callback={() => {
                                    if (this.isValidModel()) {
                                        // Add current data model to item list
                                        this.props.context.add(this.varModel);
                                    }
                                    this.varModel = this.initVarModel();
                                    this.props.domContext.removeSubmenu();
                                }}
                        />
                    );
                })()}
            </div>
        );
    }
}